<template>
    <div>
        <vs-button
            @click.native="activeModalMessage = true"
            icon="add"
            type="filled"
            color="primary"
            size="small"
            class="mb-4">Créer un nouveau sujet</vs-button>
        <div id="messagerie" class="vx-row">

            <div class="vx-col flex items-stretch w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base" :class="{'loader': subjectsLoading }">
                <vx-card>
                    <vs-table v-if="subjects" id="subject-container" :data="subjects" class="text-left" pagination
                              stripe
                              max-items="20">
                        <template slot="thead">
                            <vs-th>Titre</vs-th>
                            <vs-th>Statut</vs-th>
                            <vs-th>Actions</vs-th>
                        </template>
                        <template slot-scope="{data}">
                            <vs-tr :key="index" v-for="(subject,index) in data" @click.native="$router.push('/messagerie/'+subject.id)">
                                <vs-td :data="subject.title">
                                    <template v-if="subject.title">
                                        {{ subject.title }}
                                    </template>
                                </vs-td>
                                <vs-td :data="subject.status">
                                    <vs-chip v-if="subject.status" :color="currentStatus(subject.status).color"
                                             style="white-space: nowrap;">
                                        <strong>{{ currentStatus(subject.status).msg }}</strong>
                                    </vs-chip>
                                </vs-td>
                                <vs-td>
                                    <vs-button icon-pack="feather" type="border"
                                               color="primary" size="small"
                                               icon="icon-eye"></vs-button>
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </vx-card>
            </div>
            <div class="vx-col flex items-stretch w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base"  :class="{'loader': messagesLoading }">
                <vx-card v-if="messages && (messages.length > 0)">
                    <div id="chat-container">
                        <h5 class="my-4"><strong>Conversation : {{ subject.title }} </strong></h5>
                        <div id="chat" class="mb-4 d-flex flex-column" ref="chat">
                            <div :key="index" v-for="(message,index) of messages"
                                 class="chat-message w-75" :class="message.created_by === activeUser.id ? 'self'  : ''">
                                <div class="chat-message-body">
                                    <div class="chat-message-header">
                                        <div class="chat-message-meta d-flex flex-column">
                                        <span
                                            class="chat-message-sender">
                                            {{ message.creator.firstname }} {{ message.creator.lastname }}
                                        </span>
                                            <span
                                                class="chat-message-time"><small>
                                            {{ message.created_at | moment('DD/MM/YYYY HH:mm') }}
                                        </small></span>
                                        </div>
                                    </div>
                                    <div class="chat-message-content">
                                        <p class="mb-0 text-block">{{ message.content.trim() }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <vs-textarea v-model="message" placeholder="Votre message" type="textarea" ref="textarea" @input="resize" rows="1"
                                     id="message-textarea" class="w-full mb-4"/>

                        <vs-button @click.native="sendMessage" icon-pack="feather" type="border" color="primary" size="small"
                                   icon="icon-send">Envoyer
                        </vs-button>
                    </div>
                </vx-card>
            </div>

            <vs-prompt
                title="Créer un nouveau sujet"
                @cancel="clearSubjectForm"
                @accept="submitFormSubject"
                accept-text="Envoyer"
                cancel-text="Annuler"
                :is-valid="validMessage"
                :active.sync="activeModalMessage">
                <div class="message-form">

                    <i class="far fa-info-circle mr-2"></i>Veuillez saisir votre message ci-dessous&nbsp;:

                    <vs-input
                        type="text"
                        label="Sujet"
                        v-model="formSubject.title"
                        class="mt-4 mb-2 w-full"
                        :danger="!Boolean(formSubject.title)"
                        danger-text="Vous devez indiquer un titre"
                        placeholder="Sujet"
                        val-icon-pack="feather"
                        val-icon-danger="icon-x"
                    />

                    <vs-textarea label="Message (1000 caractères max.)" v-model="formSubject.message"
                                 class="mt-4 mb-2 w-full" counter="1000" :counter-danger.sync="counterDanger"/>
                    <vs-alert :active="!Boolean(formSubject.message)" color="danger">
                        <span class="text-sm">Vous devez saisir un message</span>
                    </vs-alert>
                </div>
            </vs-prompt>
        </div>
    </div>
</template>

<script>

import {mapActions, mapGetters, mapState} from "vuex";
import messagerieMixins from "../../mixins/messagerieMixins";

export default {
    name: "Messagerie",
    data() {
        return {
            message: '',
            activeModalMessage: false,
            formSubject: {
                title: '',
                message: ''
            },
            counterDanger: false,
        }
    },
    mixins: [messagerieMixins],
    computed: {
        ...mapState({
            subject: state => state.subject.subject,
            subjects: state => state.subject.subjects,
            subjectsLoading: state => state.subject.subjectsLoading,
            total: state => state.subject.total,
            messages: state => state.subject.messages,
            messagesLoading: state => state.subject.messagesLoading,
        }),
        ...mapGetters('user', ['activeUser']),
        validMessage() {
            return Boolean(this.formSubject.title) && Boolean(this.formSubject.message) && !this.counterDanger
        },
    },
    created() {
        this.refreshList();
        if(this.$route.params.id){
            this.getMessagesSubject(this.$route.params.id);
        }
    },
    mounted() {
        this.scrollChatBottom();
    },
    beforeRouteUpdate(to, from, next) {
        if (to.params.id !== from.params.id) {
            this.getMessagesSubject(to.params.id);
        }
        next();
    },
    methods: {
        ...mapActions('subject', ['getAllSubjects', 'addSubject', 'getMessagesOfSubject', 'postMessageToSubject']),

        refreshList() {
            this.getAllSubjects({
                page: 1,
                limit: 1000
            })
        },
        resize() {
            if(this.$refs.textarea) {
                const textarea = this.$refs.textarea.$el.querySelector('textarea');
                textarea.style.height = '0px';
                textarea.style.height = textarea.scrollHeight - 4 + 'px';
            }
        },
        getMessagesSubject(id) {
            this.getMessagesOfSubject(id).then(() => {
                this.scrollChatBottom();
            });
        },
        sendMessage() {
            if (this.message !== '') {
                this.postMessageToSubject({
                    subject_id: this.$store.state.subject.subject.id,
                    content: this.message
                }).then(() => {
                    this.$vs.notify({
                        title: 'Message envoyé',
                        text: 'Votre message a bien été envoyé',
                        color: 'success',
                        iconPack: 'feather',
                        icon: 'icon-check-circle',
                        position: 'bottom-right',
                        time: 3000
                    });
                    this.message = '';
                    this.scrollChatBottom();
                });
            }
        },
        scrollChatBottom() {
            if (this.$refs.chat) {
                this.$refs.chat.scrollTop = this.$refs.chat.scrollHeight
            }
        },
        createSubject() {
            this.activeModalMessage = true
        },
        clearSubjectForm() {
            this.formSubject.title = ''
            this.formSubject.message = ''
        },
        submitFormSubject() {
            this.addSubject({
                date: this.$moment().format(),
                title: this.formSubject.title,
                message: this.formSubject.message
            }).then(() => {

                this.clearSubjectForm()
                this.refreshList()
            })
        }
    }
}

</script>

<style>
#chat {
    max-height: 65vh;
    border: 1px solid lightgrey;
    border-radius: 4px;
    overflow-y: auto;
    padding: 16px;
    gap: 32px;
}

.chat-message-sender {
    font-weight: bold;
}

.chat-message-header {
    padding-bottom: 8px;
}

.chat-message-body {
    border-radius: 4px;
    padding: 4px 8px;
}

.chat-message {
    background: #F8F9FA;
    border-radius: 0 8px 8px 8px;
    padding: 8px;
}

.chat-message-time {
    color: #9CA2A9;
}

#message {
    min-height: 74px;
}

.chat-message.self {
    align-self: end;
    background: #DBEEFF;
    border-radius: 8px 0 8px 8px;
}

.chat-message-content {
    padding-top: 8px;
    border-top: 1px solid #E3DDDD;
}

.w-75 {
    width: 75%;
}

.d-flex {
    display: flex;
}

.flex-column {
    flex-direction: column;
}

#message-textarea{
    overflow: hidden;
    resize: none !important;
}
.text-block{
    white-space: pre-line;
    overflow-wrap: anywhere;
}
table tr{
    cursor: pointer;
}
</style>
